import { Routes, Route } from "react-router-dom";

import Home from "./pages/home";
import NotFound from "./pages/not-found";
import RouteElement from "./components/routeElement";
import PrivacyPolicy from "./pages/privacyPolicy";
import UseTerms from "./pages/useTerms";
import TermosContratacao from "./pages/contract";

//#region Courses and Services
import RedacaoEnem from "./pages/courses-and-services/redacao-enem";
import ProducaoTextualVestibulares from "./pages/courses-and-services/producao-textual-vestibulares";
import MentoriasIndividuais from "./pages/courses-and-services/one-on-one-mentoring";
import CorrecaoFeedback from "./pages/courses-and-services/correcao-feedback";
import Modalities from "./pages/courses-and-services/modalities";
import EssayCorrections from "./pages/courses-and-services/essay-corrections";
//#endregion

const PageRoutes = [
	{
		path: "/",
		name: "home",
		pageSettings: {
			header: true,
			footer: true,
			draggable: true,
			floatingAnchor: true,
			title: "Escrita Pratica",
		},
		element: <Home />,
		children: [
			{
				path: "privacy-policy",
				name: "Politica de Privacidade | Escrita Prática",
				element: <PrivacyPolicy />,
			},
			{
				path: "terms-of-use",
				name: "Termos de Uso | Escrita Prática",
				element: <UseTerms />,
			},
			{
				path: "modalidades",
				name: "Modalidades | Escrita Prática",
				element: <Modalities />,
			},
			{
				path: "termos-de-contratacao",
				name: "Termos de Contratação | Escrita Prática",
				element: <TermosContratacao />,
			},
			{
				path: "redacao-enem",
				name: "Redação ENEM | Escrita Prática",
				element: <RedacaoEnem />,
			},
			{
				path: "correcoes-para-concursos",
				name: "Correções de Redações | Escrita Prática",
				element: <EssayCorrections />,
			},
			{
				path: "producao-textual-para-vestibulares",
				name: "Produção Textual para Vestibulares | Escrita Prática",
				element: <ProducaoTextualVestibulares />,
			},
			{
				path: "mentorias-individuais",
				name: "Mentorias Individuais | Escrita Prática",
				element: <MentoriasIndividuais />,
			},
			{
				path: "correcao-com-feedback",
				name: "Correção com Feedback | Escrita Prática",
				element: <CorrecaoFeedback />,
			},
		],
	},
	{
		path: "*",
		name: "Páginas de Erro | Escrita & Prática",
		pageSettings: {
			header: true,
			footer: false,
			draggable: true,
			title: "Páginas de Erro | Escrita & Prática",
		},
		element: <NotFound />,
	},
];

export default function LandingPageRoutes() {
	function mountRoute(
		{ path, element, name, children, pageSettings },
		fatherRouteItems = [],
		fatherPageSettings = {}
	) {
		const settings = { ...fatherPageSettings, ...pageSettings };

		const routeItem = { path, name };
		const routeItems = name
			? [...fatherRouteItems, routeItem]
			: fatherRouteItems;

		const routePath = routeItems.map((x) => x.path).join("/");

		if (children) {
			return (
				<Route
					key={routePath}
					path={path}
				>
					{element && (
						<Route
							key={routePath + "/"}
							path=""
							element={
								<RouteElement
									element={element}
									routeItems={routeItems}
									pageSettings={settings}
								/>
							}
						/>
					)}
					{children.map((route) => mountRoute(route, routeItems, settings))}
				</Route>
			);
		}

		return (
			<Route
				key={routePath}
				path={path}
				element={
					<RouteElement
						element={element}
						routeItems={routeItems}
						pageSettings={settings}
					/>
				}
			/>
		);
	}

	return (
		<Routes>
			{PageRoutes.map((route) => mountRoute(route))}
			{/* <Route path="*" element={<NotFound />} /> */}
		</Routes>
	);
}